import { render, staticRenderFns } from "./DrawerMenu.vue?vue&type=template&id=c5135edc&"
import script from "./DrawerMenu.vue?vue&type=script&lang=js&"
export * from "./DrawerMenu.vue?vue&type=script&lang=js&"
import style0 from "./DrawerMenu.vue?vue&type=style&index=0&id=c5135edc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconBase: require('/home/vsts/work/1/s/components/IconBase.vue').default})
